<template>
  <div />
</template>

<script>
export default {
  name: 'Welcome',
  data() {
    return {
      showWelcome: true,
    };
  },
  mounted() {
    // Check in localstorage
    if (localStorage.showWelcome !== undefined) {
      this.showWelcome = JSON.parse(localStorage.showWelcome);
    } else {
      localStorage.showWelcome = JSON.stringify(this.showWelcome);
    }
    // Open dialog
    if (this.showWelcome) {
      this.showInfo();
    }
  },
  watch: {
    showWelcome(newShowWelcome) {
      localStorage.showWelcome = JSON.stringify(newShowWelcome);
    },
  },
  methods: {
    showInfo() {
      this.$buefy.dialog.confirm({
        type: 'is-info',
        title: this.$t('welcome.dialog.title'),
        message: this.$t('welcome.dialog.message'),
        hasIcon: true,
        icon: 'information-outline',
        cancelText: this.$t('welcome.dialog.cancelText'),
        canCancel: ['button'],
        onCancel: this.dontShowAgain,
        trapFocus: true,
      });
    },
    dontShowAgain() {
      this.showWelcome = false;
    },
  },
};
</script>
